module.exports = __webpack_public_path__ + "img/69.d2380f36.png";